import {
  VariantBoost,
  ProductBoost,
  CollectionBoost,
  CollectionBoostNormalized,
  ProductBoostNormalized,
  VariantBoostNormalized,
} from '~/types/BoostApp';

function normalizeVariant(variant: VariantBoost): VariantBoostNormalized {
  const {
    merged_options: mergedOptions,
    inventory_quantity: inventoryQuantity,
    image,
    compare_at_price: compareAtPrice,
    available,
    title,
    price,
    id,
    sku,
    barcode,
    metafields,
  } = variant;
  return {
    id,
    title,
    selectedOptions: mergedOptions.map((v) => {
      const [name, value] = v.split(':');
      return {
        name,
        value,
      };
    }),
    inventoryQuantity,
    image:
      image != null
        ? {
            width: 400,
            height: 400,
            alt: title,
            url: image,
          }
        : undefined,
    compareAtPrice,
    priceV2: {amount: price, currencyCode: 'USD'},
    compareAtPriceV2: {amount: compareAtPrice, currencyCode: 'USD'},
    available,
    sku,
    barcode,
    metafields,
  };
}
function normalizeProduct(product: ProductBoost): ProductBoostNormalized {
  const {
    body_html: description,
    skus,
    available,
    created_at: createdAt,
    updated_at: updatedAt,
    review_count: reviewCount,
    variants,
    media,
    title,
    price_min: priceMin,
    price_max: priceMax,
    images_info: images,
    review_ratings: reviewRatings,
    collections,
    vendor,
    id,
    publishedAt,
    images: imagesObject,
    options_with_values: optionsWithValues,
    handle,
    tags,
    product_type: productType,
    metafields,
  } = product;
  return {
    id,
    productType,
    tags,
    handle,
    vendor,
    featuredImage:
      images[0] != null
        ? {
            ...images[0],
            url: images[0].src,
          }
        : undefined,
    images,
    title,
    description,
    skus,
    available,
    priceMin,
    priceMax,
    reviewCount,
    reviewRatings,
    optionsWithValues,
    metafields,
    imagesObject,
    media,
    variants: variants.map((v) => normalizeVariant(v)),
    collections,
    // metadata
    createdAt,
    updatedAt,
    publishedAt,
  };
}

/**
 * Normalizes
 * */
export default function normalizeCollectionData(
  collection: CollectionBoost,
): CollectionBoostNormalized {
  const {
    total_product: totalProduct,
    total_page: totalPage,
    products,
    filter,
  } = collection;
  return {
    totalProduct,
    totalPage,
    products: products?.map((product) => normalizeProduct(product)) ?? [],
    filter: {
      options: filter?.options ?? [],
    },
  };
}
